import { cn, Tooltip } from "@win-reality/react-ui";

import {
  MACHINE_HEALTH_DOT_CLASS,
  type MachineHealth,
} from "@/utils/machineHealth";

// Standard dot + uppercase label layout for site/subsystem health.
// All state-to-{color, label, tooltip} decisions live in
// @/utils/machineHealth — this component is purely presentation. To get
// a MachineHealth value, call getMachineHealth(field) for full status, or
// subsystemHealth(boolean) when you only have a single yes/no signal.
type HealthyIndicatorProps = { health: MachineHealth };

export const HealthyIndicator = ({ health }: HealthyIndicatorProps) => {
  const body = (
    <div className="flex items-center gap-1 ml-2">
      <div
        className={cn(
          "w-2 h-2 rounded-full",
          MACHINE_HEALTH_DOT_CLASS[health.state],
        )}
      />
      <span className="text-[10px] font-regular text-gray-400 uppercase">
        {health.label}
      </span>
    </div>
  );
  if (!health.tooltip) return body;
  return (
    <Tooltip content={health.tooltip} variant="dark">
      {body}
    </Tooltip>
  );
};
